export default class Address {}
